import { SharedAppConstants } from '@tock/shared-app-constants';

export function getCsrfToken(): ApiAction {
  return {
    TockApi: {
      getProto: '/csrf-refresh',
      type: SharedAppConstants.AUTHENTICATION_CSRF_REFRESH,
    },
  };
}
